import React from 'react'
import styles from './blog.module.css'
import Markdown from "markdown-to-jsx";

export default ({data}) => (
<div>
    <div className={styles.hero}>
        <div className={styles.heroDetails}>
            <h4 className={styles.heroHeadline}>Angaben gemäß § 5 TMG</h4>
            <span>{data.name}<br/>
                {data.street}<br/>
                {data.city}</span>
            <h5 className={styles.heroHeadline}>Kontakt</h5>
            <span>Fon: {data.phone}<br/>
        Fax: {data.fax}<br/>
        Mail: {data.email}</span>
            <h5 className={styles.heroHeadline}>Redaktionell verantwortlich</h5>
            <span>{data.name}<br/>
                {data.street}<br/>
                {data.city}</span>
            <h5 className={styles.heroHeadline}>Bildnachweis</h5>
            <span>{data.bildnachweis}</span>
        </div>
    </div>
    <div className={styles.hero}>
        <div className={styles.heroSmall}>
            <Markdown options={{wrapper: 'haftung'}}>{data.haftung.haftung}</Markdown>
        </div>
    </div>

</div>
)
